import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { GalleryPath, LeadsUpload, LeadsUpload1, MessageUpload1 } from '../../app-routing.module';
import { MapleadfeldAgentComponent } from '../mapleadfeld-agent/mapleadfeld-agent.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadService } from '../../leads/lead.service';
import { UploadviewComponent } from '../uploadview/uploadview.component';
// import { LeadsService } from '../../lead/leads.service';
@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.css']
})
export class LeadDetailsComponent implements OnInit {
  @ViewChild(UploadviewComponent,{static:true}) childComponent: UploadviewComponent;
  index = ['name', 'leads', 'dialed', 'answered', 'noanswer', 'total_transfer'];
  columnsheader = ["List Name", "Total Leads", "Dialed", "Answered", "No Answer", "Transfer"];
  x: any;
  data2: any;
  collectionSize: any;
  public page = 1;
  public pageSize = 10;
  targetURL = LeadsUpload + '/leadUpload'
  leadFields: any;
  tempheadermap: any;
  msgname:any=''
  arg: { GpId: any; data: any; };
  constructor(@Inject(MAT_DIALOG_DATA) public data1: any, private dialogRef: MatDialogRef<LeadDetailsComponent>,private NgbService: NgbModal,protected lead_Service: LeadService,protected snackBar?: MatSnackBar) { }
  get_header(data?:any){
    this.lead_Service.headerData(this.data1).subscribe((res:any) => {
      console.log(res);
      this.tempheadermap = Array.isArray(res[0]) && res[0].length > 0 ? res[0][0].mapping_header : "";
      this.leadFields = Array.isArray(res[1]) && res[1].length > 0 ? res[1][0].crm_label : "";
      if(data){
        this.dialogRef.close(data)
      }
  })
}

openDncPanel() {
  window.open('https://dnc.ourdomain.com', '_blank');
}

  onComplete_Upload(event: any): void {
    console.log('eventevent', event);
    this.fieldsMapping(event.fileheader, event.uploads);
  }

  fieldsMapping(fielsdata: any, uploads: Array<{ id_upload: number; filepath: string; part_number: number }>): void {
    const modalRef = this.NgbService.open(MapleadfeldAgentComponent, {
      size: 'lg',
      centered: true,
      scrollable: true
    });
    modalRef.componentInstance.data = {
      'fileheader': fielsdata,
      'uploads': uploads,
      'leadfield': this.leadFields,
      'maphead': this.tempheadermap
    }
    modalRef.result.then((result) => {
      console.log(result)
      if (result != null && result != undefined) {
        result = JSON.parse(result)
        this.onSubmitHeaderMapping(result)
      }
    }).catch((error) => {
      console.log(error);
      if (Array.isArray(uploads)) {
        uploads.forEach(u => {
          this.lead_Service.deleteUploadFile(u.id_upload).subscribe((res: any) => {
            console.log('deleted part', u.part_number, res);
          });
        });
      }
    });
  }
  onSubmitHeaderMapping(data: any) {
    this.arg = {
      GpId: this.data1,
      data: data
    }

    this.lead_Service.saveHeaderMapping(this.arg).subscribe(rs => {
     
      console.log(rs);
      let e={target:{value:""}}
      console.log(e);
      e.target.value=this.data1
      
      
    this.lead_Service.getService('files',JSON.stringify({id_listgroup:this.data1})).subscribe((res:any) => {
      this.data2 = res;
      this.collectionSize = this.data2.length;
      this.x = this.data2
      .map((x, i) => ({ id: i + 1, ...x }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    })
    this.dialogRef.close(e)
    this.get_header(true)
    this.openSnackBar("Header mapping from uploaded contacts is mapped successfully. It may takes few minutes to process the contact file.", "Clear")
    
  },(err)=>{
    console.log(err);
     this.dialogRef.close(data)
  });

}
openSnackBar(message: string, action: string) {
  this.snackBar.open(message, action, {
    duration: 5000
    , verticalPosition: 'top',
    horizontalPosition: 'center',
    panelClass: ['snackbarwarn']
  });
}

  ngOnInit() {
    if(this.data1 instanceof Object){
      console.log(this.data1)
      this.data1=this.data1.id
      this.get_header()
      setTimeout(() => {
        this.childComponent.onClick()
      }, 500);
      // this.childComponent.onClick()
      // this.dialogRef.close()
    }
    
    
    console.log(this.data1)
    this.lead_Service.getService('files',JSON.stringify({id_listgroup:this.data1})).subscribe((res:any) => {
      console.log(res);
      this.data2 = res;
      this.collectionSize = this.data2.length;
      this.x = this.data2
      .map((x, i) => ({ id: i + 1, ...x }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    })
   this.get_header()
  }
  close(){
    this.dialogRef.close();
  }

  enableSplitting: string = 'no';
  leadsPerBatch: number | null = null;

  onBatchInput(event: any) {
    let val = +event.target.value;
    if (val > 10) val = 10;
    if (val < 1) val = 1;
    this.leadsPerBatch = val;
    event.target.value = val;
  }

  validateSplitting() {
    if (this.enableSplitting === 'yes' && !this.leadsPerBatch) {
      this.openSnackBar('Please enter leads per batch', 'Close');
      return false;
    }
    return true;
  }

}
